<!-- 首页公共头部 -->
<template>
  <div class='inside-component'>
    <div :class="['head',theme]" >
        <div class="title">
        <div class="left-contain">
            <div class="icon"></div>
            <p v-text="title"></p>
        </div>
        <div v-if="more" class="right-contain" @click="toListPage()">
            <div class="black"></div>
            <div class="red"></div>
        </div>
        </div>
        <div v-if="more" class="more" @click="toListPage()">查看更多</div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    title: {
      type: String,
      default: '头部标题'
    },
    query: {
      type: Object,
      default: {} || ''
    },
    theme: {
      type: String,
      default: 'dark'
    },
    more: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  components: {},
  computed: {},
  mounted () {
  },
  methods: {
    toListPage () { // 点击查看更多，跳到对应的列表页
      if (this.query.session !== 'fiveG') {
        this.$router.push({
          path: this.query.path,
          query: {
            tabIndex: this.query.id,
            from: this.query.from,
            session: this.query.session
          }
        })
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.head{
  margin-bottom: 20px;
  padding: 0 20px;
  .title{
    display: flex;
    justify-content: space-between;
    .left-contain{
      display: flex;
      justify-content: space-between;
      .icon{
        width: 2px;
        height: 15px;
        opacity: 1;
        background: #e50914;
        border-radius: 1px;
      }
      p{
        opacity: 1;
        font-size: 15px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: left;
        line-height: 15px;
        margin-left: 8px;
      }
    }
    .right-contain{
      display: flex;
      justify-content: space-between;
      .black{
        width: 16px;
        height: 16px;
        opacity: 1;
      }
      .red{
        width: 30px;
        height: 16px;
        background: #e50914;
        opacity: 1;
        margin-left: 2px;
      }
    }
  }
  .more{
    opacity: 1;
    font-size: 9px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: center;
    line-height: 15px;
    letter-spacing: 0px;
    text-align: right;
    margin-top: 10px;
  }
}
.dark{
  p,.more{
    color: #1c1f25;
  }
  .black{
    background: #1c1f25;
  }
}
.light{
  p,.more{
    color: #f2f2f2 !important;
  }
  .black{
    background: #f2f2f2 !important;
  }
}
</style>
